<template>
    <div class="activity-goods-list">
        <div class="expand-form" style="margin-top:0;">
            <searchForm v-model="searchData" :formItems="searchLabelList" @search="onSearch" @reset="resetForm">
                <div slot="right">
                    <el-button v-if="isEdit" size="small" type="plain" @click="onBatchRemoval">批量移除</el-button>
                </div>
            </searchForm>
        </div>
        <myTable :selection="isEdit" :page="page" :isLoading="loading" :table-data="tableData"
            :table-option.sync="tableOption" @page-change="getList" @handleSelectionChange="handleSelectionChange">
            <template slot="goodsRange" slot-scope="scope">
                {{ scope.row.goodsRange | filtersGoodsRange }}
            </template>
            <template slot="platformActivityGoodsInfoVO" slot-scope="scope">
                <div class="goods-info" v-if="scope.row.platformActivityGoodsInfoVO">
                    <div class="goods-info-image">
                        <el-image :src="scope.row.platformActivityGoodsInfoVO.image || avater" lazy style="width:100%;height: 100%;" />
                    </div>
                    <div class="goods-info-content">
                        <p class="goods-name">
                             {{ scope.row.platformActivityGoodsInfoVO.goodsName }}
                        </p>
                        <p>
                            规格: {{ scope.row.platformActivityGoodsInfoVO.specification || '-'}}
                        </p>
                        <p>
                            生产厂家: {{ scope.row.platformActivityGoodsInfoVO.factory || '-'}}
                        </p>
                        <p>
                            69码: {{ scope.row.platformActivityGoodsInfoVO.barCode || '-'}}
                        </p>
                    </div>
                </div>
            </template>
            <template slot="operation" slot-scope="scope" v-if="isEdit">
                <div style="margin: 0 0px">
                    <el-link type="primary" :underline="false" @click="deletActive(scope.row, 'detel')"
                        style="margin-right: 10px">
                        移除
                    </el-link>
                </div>
            </template>
        </myTable>
    </div>
</template>
<script>
const ruleTypeOptions = [
    {
        name: "基准库分类",
        id: 0,
    },
    {
        name: "指定店铺",
        id: 1,
    },
    {
        name: "店铺指定商品",
        id: 2,
    },
];
import searchForm from "./searchForm.vue";
import myTable from "@/components/myTable";
import { activityGoodsInfo, activityGoodsDelete, deleteActivityGoodsList } from "@/api/platActivityManage";
import avater from "/public/img/default.png"
// 平台活动商品
export default {
    components: { searchForm, myTable },
    props: {
        isEdit: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            avater,
            id: this.$route.query.id,
            searchLabelList: [
                {
                    name: "商品范围",
                    fieldName: "goodsRange",
                    type: "select",
                    select: ruleTypeOptions,
                },
                {
                    name: "搜索店铺名称",
                    fieldName: "shopName",
                    type: "input",
                    show(e) {
                        // 联动 当商品范围为“指定店铺、店铺指定商品时”，店铺名称下拉框显示
                        const bool = [1, 2].includes(e.goodsRange);
                        if (!bool) {
                            e.shopName = ''
                        }
                        return bool
                    }
                },
                {
                    name: "搜索商品信息",
                    fieldName: "goodsInfo",
                    type: "input",
                },
                {
                    fieldName: "date",
                    type: "daterange",
                    width: 240,
                    $attrs: {
                        placeholder: '更新时间'
                    }
                },

            ],
            searchData: this.searchDataInit(),
            loading: false,
            page: {
                total: 0,
                current: 1,
                size: 10,
                pageSizes: [10, 20, 30, 50],
            },
            tableData: [],
            tableOption: [
                { label: "商品范围", prop: "goodsRange", slot: true },
                { label: "店铺名称", prop: "shopName", },
                { label: "商品信息", prop: "platformActivityGoodsInfoVO", slot: true, minWidth: 200 },
                { label: "SKU活动库存下限", prop: "skuInventoryMin", },
                { label: "SKU价格上限", prop: "skuPriceMax", type: 'money' },
                { label: "活动价", prop: "activityPrice", type: 'money' },
                { label: "更新人", prop: "updateBy", },
                { label: "更新时间", prop: "updateTime", },
                { label: "操作", prop: "operation", slot: true },
            ],
            selectionList: []
        };
    },
    filters: {
        // 商品范围：0基准库商品 1指定店铺全部商品 2店铺指定商品
        filtersGoodsRange(e) {
            const obj = ruleTypeOptions.find(i => i.id === e)
            return obj?.name || e
        }
    },
    created() { },
    mounted() { },
    methods: {
        handleSelectionChange(val) {
            this.selectionList = val;
        },
        searchDataInit() {
            return {
                shopName: '', // 店铺名称
                goodsInfo: '', // 商品信息
                goodsRange: '', // 商品范围
                date: []
            }
        },
        onSearch() {
            this.page.current = 1;
            this.getList();
        },
        // 批量删除
        onBatchRemoval() {
            console.log('selectionList', this.selectionList)
            if (!this.selectionList.length) {
                this.$message.warning('请勾选要移除的商品')
                return
            }
            this.$confirm(`确定要移除勾选的商品吗?`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                    const ids = this.selectionList.map(({ id }) => id)
                    deleteActivityGoodsList(ids).then(res => {
                        this.$message.success('操作成功！')
                        this.getList()
                    })

            }).catch(() => { });

        },
        resetForm() {
            this.page.current = 1;
            this.searchData = this.searchDataInit();
            this.getList();
        },
        getList() {
            const { date, ...form } = this.searchData;
            const { current, size } = this.page;
            const params = {
                ...form,
                current,
                size,
                activityId: this.id
            };
            if (date && date.length) {
                params.strTime = date[0];
                params.endTime = date[1];
            }
            this.loading = true
            activityGoodsInfo(params).then((res) => {
                this.tableData = res.records || [];
                this.page.total = res.total || 0;
            }).finally(() => {
                this.loading = false
            })
        },
        // 移除商品
        deletActive(row) {
            this.$confirm(`确定要移除该商品吗?`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                if (row.id) {
                    // 删除活动商品
                    activityGoodsDelete(row.id).then((res) => {
                        this.$message.success('操作成功！')
                        this.getList()
                    }).catch((err) => { })
                }

            }).catch(() => { });

        },
        goBack() {
            this.$router.back(-1)
        }
    },
};
</script>
<style lang="scss" scoped>
::v-deep.el-table {
    height: calc(100% - 138px) !important;
}

::v-deep.zt__table {
    height: calc(100% - 97px) !important;
}

::v-deep.el-table .el-table__body-wrapper {
    height: calc(100% - 78px) !important;
    overflow-y: scroll !important;
}

.activity-goods-list {
    height: 100%;
}

.expand-form {
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
}

.flex-box {
    display: flex;
    justify-content: space-between;

    &.al-center {
        align-items: center;
    }
}

.goods-info {
    min-width: 150px;
    display: flex;
    align-items: flex-start;

    &-image {
        width: 80px;
        height: 80px;
        flex-shrink: 0;
    }

    &-content {
        margin-left: 8px;

        p {
            margin: 0;
            font-size: 12px;
        }

        .goods-name {
            font-weight: 600;
        }
    }
}
</style>
